import { render, staticRenderFns } from "./appointUser.vue?vue&type=template&id=09716590&scoped=true&"
import script from "./appointUser.vue?vue&type=script&lang=js&"
export * from "./appointUser.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09716590",
  null
  
)

export default component.exports